import React, { Component } from 'react'
import { connect } from 'react-redux'
import VaultResTokenizeCCSample from '../samples/VaultResTokenizeCCSample'
import { makeVaultResTokenizeCC } from '../../../actions/vaultAction'
import { updateOrderId } from '../../../actions/commonActions'
import { _VAULT } from '../../../actions/types'
import TokenizeImage  from '../../../images/tokenize.png'
const OBJECT = [  "resTokenizeCC", "resTokenizeCC", "resTokenizeCC"]
const METHODS = { 
    SetEncTrack2:[  ".SetEncTrack2(enc_track2);", ".SetEncTrack2(enc_track2);", "'enc_track2'=>$enc_track2"],
    SetDeviceType:[  ".SetDeviceType;", ".SetDeviceType;", "'device_type'=>$device_type"],
    SetCusId: [  ".SetCustId(cust_id);", ".setCustId(cust_id);", "'cust_id'=>$cust_id"],
    SetAvsCheck: [  ".SetAvsInfo(avsCheck);", ".setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    SetEmail: [  ".SetEmail(email);", ".setEmail(email);", "'email'=>$email"],
    SetPhone: [  ".SetPhone(phone);", ".setPhone(phone);", "'phone'=>$phone"],
    SetNote: [  ".SetNote(note);", ".setNote(note);", "'note'=>$note"],
    SetDataKeyFormat: [  ".SetDataKeyFormat(data_key_format);", ".SetDataKeyFormat(data_key_format);", "'data_key_format'=>$data_key_format"],
    SetDataKey: [  ".setData(data_key);", ".setData(data_key);", "'data_key'=>$data_key"],
    CreditCardNumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    ExpiryDay: [  ".setExpdate(expiry_date);", ".setExpdate(expiry_date);", "'expdate'=>$expiry_date"],
    SetDuration: [  ".SetDuration(duration);", ".SetDuration(duration);", "'duration'=>$duration"],
    CreditCardCumber: [  ".SetPan(pan);", ".setPan(pan);", "'pan'=>$pan"],
    SetCryptType: [  ".SetCryptType(crypt);", ".setCryptType(crypt);", "'crypt_type'=>$crypt"],    
    setCotInfo: [  ".SetCofInfo(cof);", ".setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    SetIssueId: [  `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{cof.SetIssuerId("VALUE_FOR_ISSUER_ID");}`, `{$cof->setIssuerId("VALUE_FOR_ISSUER_ID");}`],
    SetOrderId: [  "SetOrderId(order_id);", "SetOrderId(order_id);", "'order_id'=>$order_id"],
    SetTxnNumber: [  "SetTxnNumber(txn_number);", "setTxnNumber(txn_number);", "'txn_number'=>$txn_number"]
}
export class VaultTokenizeCC extends Component {
    state = {
        showError:false,
        showSuccess:false,
        justClicked:false,
      };
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}>
                    <strong>Error!</strong><br />
                    Please check your parameters within Vault ResTokenizeCC.
                </div>
            );
        }
        // else if(this.state.showSuccess) {
        //     return (
        //         <div style={{ marginTop:'-2vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}>
        //             <strong>Vault ResTokenizeCC Accepted!</strong><br />
        //             The returned receipt has been inserted to the JSON on the right, you can make another Vault Request now.
        //         </div>
        //     );
        // }
    }

    //TODO fix this
    componentDidUpdate() {
        const { restokenizeccSuccess,ResTokenizeeCCResponse,loading } = this.props; 
        if(ResTokenizeeCCResponse!=="No request has been made."  && this.state.justClicked){
            if(restokenizeccSuccess){
                    this.setState({ showError: false,showSuccess: true,justClicked:false });  
                }
            else {
                if(!loading){
                    this.setState({  showError: true, showSuccess: false,justClicked:false });
                }
            }
        }
    }
    //TODO fix this
    async onMakePurchasePress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _VAULT, orderId: newOrderId });
        const { storeId, apiToken, order_id, pan, expdate, amount } = this.props;
        const tokenizeRequest = { storeId, apiToken, order_id, pan, expdate, amount };
        this.props.makeVaultResTokenizeCC(tokenizeRequest);
        this.setState({justClicked:true});
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample ResTokenizeCC</h3>
                <VaultResTokenizeCCSample/>
                <div className="requestButton" onClick={() => this.onMakePurchasePress()}>
                    ResTokenizeCC Request
                </div> 
                {this.renderMessage()}
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }


    renderDocument() { 
        const { progLangId } = this.props;
        return (
            <div className="stepPageContainer">
            <h3 className="stepPageTitle">Vault Tokenize Credit Card – ResTokenizeCC</h3>
            <p>Creates a new credit card profile using the credit card number, expiry date and e-commerce indicator
                that were submitted in a previous financial transaction. Previous transactions to be tokenized must have
                included the Credential on File Info object.<br/>
                The Issuer ID received in the previous transaction response is sent in the Vault Tokenize Credit Card
                request to reference that this is a stored credential.
            </p>
            <p><b>Basic transactions that can be tokenized are:</b></p>   
            <ul>
                <li>Purchase</li>
                <li>Pre-Authorization</li>
                <li>Card Verification</li>
            </ul>

  
            <p><b>The tokenization process is outlined below :</b></p>   
            <p style={{marginLeft:"28vw"}}>Figure 1: Tokenize process diagram</p>
            <img style={{ width: '80%',marginLeft:"10vw", height: 'auto',minHeight:"1px"}} src={TokenizeImage} alt='' /> 
            <p><b>Vault Tokenize Credit Card transaction object definition</b></p>   
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>ResTokenizeCC resTokenizeCC = new ResTokenizeCC();
                            </code>
                        case 1:
                            return <code>ResTokenizeCC resTokenizeCC = new ResTokenizeCC();

                            </code>
                        case 2:
                            return <code>
                                {`$txnArray = array(‘type’=>’res_tokenize_cc', …);`}<br/>
                                {`$mpgTxn = new mpgTransaction($txnArray);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
            <p><b>HttpsPostRequest object for Vault Tokenize Credit Card transaction</b></p>   
            {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();
                            </code>
                        case 1:
                            return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();

                            </code>
                        case 2:
                            return <code>
                                {`$mpgRequest = new mpgRequest($mpgTxn);`}
                                </code>
                        default:
                            return null
                        }
                    })()}<br/>
                   {(() => {
                    switch(progLangId) {
                        case 0:
                            return <code>mpgReq.SetTransaction(resTokenizeCC);</code>
                        case 1:
                            return <code>mpgReq.SetTransaction(resTokenizeCC);</code>
                        case 2:
                            return <code>
                                {`$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);`}
                                </code>
                        default:
                            return null
                        }
                    })()}
            
            <p><b>Vault Tokenize Credit Card transaction request fields – Required</b></p>   


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Add Credit Card transaction request fields – Required</h3>
        <p>These mandatory values reference a previously processed credit card financial transaction. The credit
                card number, expiry date, and e-commerce indicator from the original transaction are registered in the
                Vault for future financial Vault transactions.
        </p>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>order ID</td>
                    <td>String<br/>50-character alphanumeric<br/>{`a-Z A-Z 0-9 _ - : . @ spaces`}</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetOrderId[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>transaction number<br /></td>
                    <td>String<br/>255-character, alphanumeric,hyphens or underscores<br/>variable length</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetTxnNumber[progLangId]}</code></td>
                </tr>
                </tbody>
            </table>


        <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault Tokenize Credit Card transaction request fields – Optional</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>customer ID</td>
                    <td>String<br/>
                        50-character alphanumeric<br/> 
                            <p className="note">
                                <strong>NOTE: </strong> 
                                Some special characters are not
                                allowed:
                                {`< > $ % = ? ^ { } [ ] \\`}
                            </p>
                        </td>
                        <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetCusId[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>email address<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetEmail[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>phone number<br /></td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetPhone[progLangId]}</code></td>
                </tr>
                <tr>
                    <td>note</td>
                    <td>String<br/>30-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetNote[progLangId]}</code></td>
                </tr>

                <tr>
                    <td>AVS Information</td>
                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetAvsCheck[progLangId]}</code></td>

                </tr>

                <tr>
                    <td>data key format</td>
                    <td>String<br/>2-character alphanumeric</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetDataKeyFormat[progLangId]}</code></td>
                </tr>
              
                <tr>
                    <td>
                        Credential on File Info<br/>
                        cof<br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This is a nested object
                                within the transaction, and
                                required when storing or
                                using the customer's stored
                                credentials. For information
                                about fields in the Credential
                                on FIle Info object, see Credential
                                on File Info Object
                                and Variables. 
                            </p>
                    </td>

                    <td>Object<br/>N/A</td>
                    <td><code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.setCotInfo[progLangId]}</code></td>
                </tr>

                



                </tbody>
            </table>


            <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Credential on File Info object request fields</h3>
            <table style={{maxWidth:"100%", width:"100%"}}>
            <tbody>
                <tr>
                    
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>
                </tr>
                <tr>
                    <td>issuer ID <br/>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                This variable is
                                required for all merchant-initiated
                                transactions following
                                the first one; upon sending
                                the first transaction, the
                                issuer ID value is received in
                                the transaction response and
                                then used in subsequent
                                transaction requests.
                            </p>
                    </td>
                    <td>String<br/>
                        15-character alphanumeric<br/>
                        variable length 
                    </td>
                    <td>
                    <code>{progLangId !== 2 ? OBJECT[progLangId] : ''}{METHODS.SetIssueId[progLangId]}</code>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                For a list and explanation of the
                                possible values to send for this variable,
                                see Definition of Request Fields – Credential
                                on File
                            </p>
                    </td>
                </tr>
                </tbody>
            </table>
            <p>Any field that is not set in the tokenize request is not stored with the transaction. That is, Moneris Gateway
does not automatically take the optional information that was part of the original transaction.<br/>
The ResolveData that is returned in the response fields indicates what values were registered for this profile.</p>
            <h3 className="stepPageTitle" style={{ fontSize:"1.2vw"}}>Vault response fields</h3>
            <p>For a list and explanation of (Receipt object) response fields that are available after sending this Vault
                transaction, see Definitions of Response Fields.
            </p>          
          </div>
        )
    }
}


const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { restokenizeccSuccess,ResTokenizeeCCResponse,loading } = state.vault.main;
    const { storeId, apiToken, order_id, pan, expdate, amount} = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, pan, expdate, amount,loading, progLangId: state.common.progLangList.selection,restokenizeccSuccess,ResTokenizeeCCResponse };
  }

export default connect(mapStateToProps,{updateOrderId,makeVaultResTokenizeCC})(VaultTokenizeCC) 